import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

export default function Layout() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const close = () => setOpen(false);

  // Close the mobile drawer whenever the route changes
  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <div className={`app-shell${open ? ' menu-open' : ''}`}>
      <Sidebar onNavigate={close} />
      <div className="sidebar-backdrop" onClick={close} />
      <div className="main-area">
        <Navbar onToggleSidebar={() => setOpen((o) => !o)} />
        <main className="page-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
